import React from 'react';
import { Link } from 'react-router-dom';

function MissingDoc() {
    return (
        <>
            <div className="bg-gray-100">
                <div className='w-[100%] h-2 bg-primarygreen rounded-r-full'>
                </div>
            </div>
            <div className="flex justify-center items-center bg-gray-100 py-20">
                <div className="mx-6 w-[95%] md:w-[60%] lg:w-[40%] bg-white p-8 rounded-lg shadow-md">
                    <h2 className="text-2xl font-pop font-bold mb-4">Identity verification</h2>
                    <p className="text-black font-pop text-lg mb-2">To make sure it’s really you, Upload Missing Docs</p>
                    <p className="text-gray-600 font-pop mb-2">That way we can be sure someone isn’t trying to set up an account in your name.</p>

                    {/* <form> */}

                    <button className="my-4 w-full bg-green-500 hover:bg-transparent  hover:bg-white-500 font-semibold hover:text-black font-pop text-xl py-3 px-4 border border-black-500 hover:border-green-500 rounded-full  text-white animate__animated animate__backInUp ">
                        <Link to={`/user-dashboard/upl_missing_doc`}>
                            Got It
                        </Link>
                    </button>
                    {/* </form> */}
                </div>
            </div>
        </>
    );
}

export default MissingDoc;
